import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { ApiService } from  'src/app/services/api';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Header, Trace,EventMonitoring,SystemInfo } from '../models/trace.model';  // Import the interfaces
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'search-table',
    imports: [
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatInputModule,
        MatFormFieldModule,
        MatCardModule,
        MatButtonModule,
        FormsModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatIconModule
    ],
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit {
  displayedColumns: string[] = ['severity', 'masterCode', 'message', 'timeStamp', 'sourceSystem', 'targetSystem'];
  //dataSource: MatTableDataSource<string> = new MatTableDataSource();
  groupedData: any[] = [];
  // Filters
  eventName: string | null = null;
  masterCode: string | null = null;
  //filter: string | null = null;
  loading = false;
  sendingTicket = false;
  header!: Header;  // Store header information
  traces: Trace[] = []; // Array to hold the traces
  noTracesFound = false;
  error:any | null = null;
  severityLevel: string | null = null;
  eventOptions : EventMonitoring[] = [];
  sourceSystems: SystemInfo[] = [];
  sourceSystem: string | null = null;
  targetSystems: SystemInfo[] = [];
  targetSystem: string | null = null;
  errorsCount: number = 0;

severityOptions = [
  { label: 'Info', value: '1' },
  { label: 'Warning', value: '2' },
  { label: 'Error', value: '3' }
];
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {   
    this.loadEvents();
    this.loadSourceSystem();
    this.loadTargetSystem();
     this.loadErrorsCount();
  }

  loadEvents():void{
    this.apiService.getAllEvents().subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) 
          {
             this.noTracesFound = true;
          } 
          else 
          {
            this.eventOptions = [];
             for (const eventMonitoring  of data) 
             {
               this.eventOptions.push(eventMonitoring);
             }            
          }
          this.loading = false; },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      });
  }

  loadErrorsCount():void{
    this.apiService.getErrorsCount().subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) 
          {
             this.noTracesFound = true;
          }
          else
          {
            this.errorsCount = data;
          }
          this.loading = false; },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      });
  }

  loadSourceSystem():void{
    this.apiService.getSourceSystem().subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) 
          {
             this.noTracesFound = true;
          }
          else 
          {
            this.sourceSystems = [];
             for (const sourceSystem  of data) 
             {
               this.sourceSystems.push(sourceSystem);
             }
          }
          this.loading = false; },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      });
  }

  loadTargetSystem():void{
    this.apiService.getTargetSystem().subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) 
          {
             this.noTracesFound = true;
          }
          else 
          {
            this.targetSystems = [];
             for (const targetSystem  of data) 
             {
               this.targetSystems.push(targetSystem);
             }            
          }
          this.loading = false; },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      });
  }

  loadData(): void {
    console.log("load data");
    this.loading = true;
    this.noTracesFound = false;
    this.apiService.searchTraces(this.eventName, this.masterCode, this.severityLevel,this.sourceSystem,this.targetSystem).subscribe({
      next: (data) => {
        console.log(data); // Assign the data to dataSource
        if(data == null) {
          this.noTracesFound = true;
        } else {
          this.header = data.Header;  // Store the header data separately
          this.traces = data.Traces;  // Store the header data separately
          //this.dataSource = new MatTableDataSource(data.Traces) || [];
          this.prepareGroupedData( data.Traces);
        }
        this.loading = false;},
      error: (message) => {
        console.error(message);
        this.loading = false;
        // General error handling
        this.error = {
          message: 'Failed to fetch logs from the server.',
          details: message || 'Unknown error occurred.'       
        };
      }
    })
  }

  prepareGroupedData(traces: Trace[]): void {
    this.groupedData = [];
    let currentGroupId: string | null = null;
 
    for (const trace of traces) {
      if (trace.EventId !== currentGroupId) {
        currentGroupId = trace.EventId;
        this.groupedData.push({ group: true, EventId: currentGroupId, EventName:trace.EventName });
      }
      this.groupedData.push(trace);
    }
  }
  
  // Predicate to determine row type
  isGroup = (index: number, item: any): boolean => item.group === true;
  isData = (index: number, item: any): boolean => !item.group;

  applySearch(): void 
  {
    if(this.eventName!==null || this.masterCode!==null)
      {
        this.loadData();
      }    
  }

  clearFilters(): void {
    this.eventName = null;
    this.masterCode = null;
    this.severityLevel = null;
    this.sourceSystem = null;
    this.targetSystem = null;
  }

  /*CleanFilter(): void {
    this.filter = null;
    this.dataSource.filter = '';
  }
  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.toLowerCase().trim();
  }*/

  getSeverityLabel(level: string): string {
  switch (level) {
    case '1':
      return 'Info';
    case '2':
      return 'Warning';
    case '3':
      return 'Error';
    default:
      return level;
  }
}
}